var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { forwardRef, useContext } from 'react';
import { View } from 'react-native';
import { StateConfigContext } from '../../providers';
import { getTestId } from '../../utils';
import { DynamicSvg } from '../dynamic-svg';
import { GradientView } from '../gradient-view';
import { Typography } from '../typography';
import { getInfoTagProps, getInfoTagStyles, getInfoTagTextStyle, infoTagColorStyles } from './InfoTagStyles';
export var InfoTag = forwardRef((props, ref) => {
  var _a, _b, _c, _d, _e;
  var stateContext = useContext(StateConfigContext);
  var infoTagProps = getInfoTagProps(props, stateContext);
  var config = infoTagProps.config,
    style = infoTagProps.style,
    iconProps = infoTagProps.iconProps,
    text = infoTagProps.text,
    size = infoTagProps.size,
    type = infoTagProps.type,
    subType = infoTagProps.subType,
    iconName = infoTagProps.iconName,
    _infoTagProps$testID = infoTagProps.testID,
    testID = _infoTagProps$testID === void 0 ? 'InfoTag' : _infoTagProps$testID,
    disabled = infoTagProps.disabled,
    restProps = __rest(infoTagProps, ["config", "style", "iconProps", "text", "size", "type", "subType", "iconName", "testID", "disabled"]);
  var isGradientView = ['offer'].includes(subType);
  var infoTagStyles = getInfoTagStyles(infoTagProps);
  var gradientType = (_b = (_a = config === null || config === void 0 ? void 0 : config.subType) === null || _a === void 0 ? void 0 : _a[subType]) === null || _b === void 0 ? void 0 : _b.gradientType;
  var OuterWrapper = isGradientView ? GradientView : View;
  var colorsConfig = infoTagColorStyles(infoTagProps);
  return _jsx(_Fragment, {
    children: !!text && _jsxs(OuterWrapper, Object.assign({
      ref: ref,
      style: [infoTagStyles.container, style],
      accessibilityLabel: text
    }, isGradientView && {
      type: gradientType
    }, getTestId(testID), restProps, {
      children: [!!iconName && _jsx(DynamicSvg, Object.assign({
        fontSize: (_e = (_d = (_c = config === null || config === void 0 ? void 0 : config.size) === null || _c === void 0 ? void 0 : _c[size]) === null || _d === void 0 ? void 0 : _d[type]) === null || _e === void 0 ? void 0 : _e.iconSize,
        iconName: iconName,
        style: infoTagStyles.iconContainer
      }, iconProps, {
        disabled: disabled,
        color: colorsConfig.color
      }, getTestId(testID, 'icon'))), _jsx(Typography, Object.assign({
        type: getInfoTagTextStyle(size, type),
        color: colorsConfig.color,
        text: text,
        allowFontScaling: false
      }, getTestId(testID, 'text')))]
    }))
  });
});